<template>
     <div>
        <div v-if="assign.passTypeId === $parent.getPassTypeId('Universal')">
            <v-btn
                v-if="assign.id !== null"
                class="my-2"
                block
                :disabled="loading"
                :loading="loading"
                @click.prevent="$parent.passLearningTest(assign, assign.id, $parent.getPassTypeId('Control'))">
                Пройти тест для контроля
            </v-btn >
            <v-btn
                class="my-2"
                block
                :disabled="loading"
                :loading="loading"
                @click.prevent="$parent.passLearningTest(assign, null, $parent.getPassTypeId('SelfStudy'))">
                Пройти тест для обучения
            </v-btn >
        </div>
        <div v-else>
            <v-btn
                class="my-2"
                block
                :disabled="loading"
                :loading="loading"
                @click.prevent="$parent.passLearningTest(assign, assign.id, assign.passTypeId)">
                Пройти тест для {{ assign.passTypeId === $parent.getPassTypeId('Control') ? 'контроля' : 'обучения' }}
            </v-btn >
        </div>
    </div>
</template>

<script>
export default {
    name: 'PassLearningButton',
    props: {
        assign: Object,
        loading: Boolean
    }
}
</script>
